import React, { useRef } from 'react';
import ProductCard from '../../Components/ProductCards/ProductCard';
import useIsAuthenticated from '../../Hooks/useIsAuthenticated';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import { Pagination, Navigation } from 'swiper';
import Icon from '../../Components/Icon';
import clsx from 'clsx';

const Products = ({ isSlider, link, products, title }) => {
  const swiperRef = useRef(null);
  const prevBtnRef = useRef(null);
  const nextBtnRef = useRef(null);
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <div className="products-block__header">
        <div className="products-block__header--left">
          {title && <h2 className="products-block__title">{title}</h2>}
        </div>
        <div className="products-block__header--right">
          {link && (
            <a
              href={link.href}
              className={clsx(
                'products-block__link',
                isSlider && 'products-block__link--is-slider'
              )}
            >
              {link.text}
            </a>
          )}
          {isSlider && (
            <div className="products-block__header-buttons">
              <button
                className="products-block__header-button"
                ref={prevBtnRef}
              >
                <Icon
                  name="Caret-Left"
                  size={24}
                  className="products-block__header-button-icon"
                />
              </button>
              <button
                className="products-block__header-button"
                ref={nextBtnRef}
              >
                <Icon
                  name="Caret-Right"
                  size={24}
                  className="products-block__header-button-icon"
                />
              </button>
            </div>
          )}
        </div>
      </div>
      {products && !!products.length && isSlider ? (
        <div className="products-block__swiper-wrapper">
          <Swiper
            ref={swiperRef}
            spaceBetween={16}
            slidesPerView={1}
            slidesPerGroup={1}
            pagination={true}
            loop={false}
            modules={[Pagination, Navigation]}
            navigation={{
              prevEl: prevBtnRef.current,
              nextEl: nextBtnRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevBtnRef.current;
              swiper.params.navigation.nextEl = nextBtnRef.current;
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 24,
              },
              1280: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={'slide-' + product.id}>
                <ProductCard {...product} isAuthenticated={isAuthenticated} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <ul className="products-block__list">
          {products.map((product) => (
            <ProductCard
              {...product}
              isAuthenticated={isAuthenticated}
              key={product.id}
            />
          ))}
        </ul>
      )}
    </>
  );
};

export default Products;
